"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const andes_react_1 = require("@yonderland/andes-react");
exports.default = () => andes_react_1.packageVersion;
